function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.25 23H15.1c1.41 0 2.43-.48 2.75-1.96l.66-3.08h2.74A2.75 2.75 0 0024 15.2V8.5c0-1.68-1.36-2.57-2.68-2.52h-6.91V3.76A2.75 2.75 0 0011.66 1H2.75A2.75 2.75 0 000 3.75v16A3.25 3.25 0 003.25 23zM14.41 7.49h4.86a2.9 2.9 0 00-.15.48l-2.74 12.76c-.25 1.17-1.97.99-1.97-.21V7.49zm-9.63.01a.75.75 0 110-1.5.75.75 0 010 1.5zm0 9.02h5a.75.75 0 110 1.5h-5a.75.75 0 110-1.5zm0-5.27h5a.75.75 0 110 1.5h-5a.75.75 0 110-1.5z"
}));